/**
 * Componente de Chips para filtrar por fonte do histórico
 */

import React from "react";
import type {
	TimelineSourceFilter,
	TimelineSourcesCount,
} from "../../../types/historico";
import { getSourceLabel } from "../../../utils/historicoNormalizer";

interface HistoricoSourceChipsProps {
	activeSource: TimelineSourceFilter;
	onSourceChange: (source: TimelineSourceFilter) => void;
	sourcesCount?: TimelineSourcesCount | null;
	loading?: boolean;
}

const SOURCE_OPTIONS: TimelineSourceFilter[] = [
	"all",
	"file_save",
	"pre_file_save",
	"orcamentos_temp",
];

export function HistoricoSourceChips({
	activeSource,
	onSourceChange,
	sourcesCount,
	loading = false,
}: HistoricoSourceChipsProps) {
	const getCount = (source: TimelineSourceFilter): number | null => {
		if (!sourcesCount) return null;
		if (source === "all") return sourcesCount.total;
		return sourcesCount[source] ?? null;
	};

	return (
		<div className="flex flex-wrap gap-2">
			{SOURCE_OPTIONS.map((source) => {
				const isActive = activeSource === source;
				const count = getCount(source);

				return (
					<button
						key={source}
						onClick={() => onSourceChange(source)}
						disabled={loading}
						className={`
							px-3 min-h-[44px] rounded-full text-xs font-medium transition-all duration-200
							flex items-center gap-1.5
							disabled:opacity-50 disabled:cursor-not-allowed
							${
								isActive
									? "bg-blue-500 text-white shadow-md"
									: "bg-navy-700 text-gray-300 hover:bg-navy-600 hover:text-white"
							}
						`}
					>
						<span>{getSourceLabel(source)}</span>
						{count !== null && count > 0 && (
							<span
								className={`
								px-1.5 py-0.5 rounded-full text-xs font-semibold
								${isActive ? "bg-blue-400/30 text-white" : "bg-navy-600 text-gray-400"}
							`}
							>
								{count}
							</span>
						)}
					</button>
				);
			})}
		</div>
	);
}
